export default "__VITE_ASSET__Dh4MHRf7__"